import { render, staticRenderFns } from "./DatasetName.vue?vue&type=template&id=57969c96&scoped=true&"
import script from "./DatasetName.vue?vue&type=script&lang=js&"
export * from "./DatasetName.vue?vue&type=script&lang=js&"
import style0 from "./DatasetName.vue?vue&type=style&index=0&id=57969c96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57969c96",
  null
  
)

export default component.exports